import React from 'react';
import PropTypes from 'prop-types';
import Button from 'material-ui/Button';
import { DialogActions, DialogContent } from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';

export class SubscribeForm extends React.Component{
  constructor() {
    super();
    this.state = {
      FNAME: '',
      EMAIL: ''
    };
    this.handleChnage = this.handleChnage.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentDidUpdate() {
    const { status, onClose } = this.props;
    if (status === 'success') {
      setTimeout(onClose, 10000);
    }
  }

  onCancel() {
    const { onClose } = this.props;
    onClose();
  }

  onSubmit() {
    const { onValidated } = this.props;
    onValidated(this.state);
  }

  handleChnage(key) {
   return event => this.setState({
      [key]: event.target.value,
    });
  }

  render() {
    const { status, message, text } = this.props;
    const { EMAIL, FNAME} = this.state;

    return (
      <div>
        <DialogContent>
          <TextField
            autoFocus
            autoComplete="off"
            margin="dense"
            id="email"
            label="Email Address"
            type="email"
            value={EMAIL}
            onChange={this.handleChnage('EMAIL')}
            fullWidth
          />
          <TextField
            margin="dense"
            autoComplete="off"
            id="name"
            label="Name"
            type="text"
            value={FNAME}
            onChange={this.handleChnage('FNAME')}
            fullWidth
          />
          {status === "sending" && <div style={{ color: "blue" }}>sending...</div>}
          {status === "error" && (
            <div
              style={{ color: "red" }}
              dangerouslySetInnerHTML={{ __html: message }}
            />
          )}
          {status === "success" && (
            <div
              style={{ color: "green" }}
              dangerouslySetInnerHTML={{ __html: message }}
            />
          )}
        </DialogContent>
        {text}
        <DialogActions>
          <Button onClick={this.onCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.onSubmit} color="primary" autoFocus>
            Sign up! 
          </Button>
        </DialogActions>
      </div>
    );
  }
}

SubscribeForm.propTypes = {
  status: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  onValidated: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SubscribeForm;


// WEBPACK FOOTER //
// ./src/components/HomePage/Iteq/SubscribeForm.jsx